import React from "react";

import { FaUnlock, FaLock } from "react-icons/fa";

import Config from '../../../config/config';
import thumb_certificate from "../../../assets/img/certificate-400x225.jpg";
import { addToDataLayerGTM } from '../../../utils/addToDataLayerGTM'
import LmsService from "../../../services/LmsService";

export default function ModuleCertificateComponent({
   courseFinishState,
   courseFinishedDB,
   course
}) {
  async function handleCheckURL(){
    const lmsService = new LmsService();
    const response = await lmsService.getCourse(course.id);

    // Google Tag Manager
    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

    const dataLayer ={
      'event' : 'solicitacao_servico',
      'nome_servico' : 'gerar_certificado:curso',
      'nome_curso' :  response.data.course.title || '',
      'data_servico' : formattedDate,
      'produto' : response.data.course.title || '',
      'brand' : 'porto seguro',
      'retorno' : course.id ? 'sucesso' : 'erro',
      'descricao' : 'certificado gerado'
      }

    addToDataLayerGTM(dataLayer);
    window.customData.curso.indice = window.customData.curso.modulos;
    window.customData.curso.etapa = "emissao-de-certificado";

  }
  let urlDownloadCertificate;

  if (courseFinishState || courseFinishedDB) {
    const codeUrl = courseFinishState | courseFinishedDB;
    urlDownloadCertificate = `${Config.baseUrl}/api/v1/lms/certified_generate/?u=${codeUrl}`;
  }
   else {
    urlDownloadCertificate = false;
  }

  return (
    <div key={1} className="course-item-sider-bar">
      <a
        className={`proof_slide ${!(courseFinishState || courseFinishedDB) && "disabled"}`}
        href={urlDownloadCertificate}
        data-gtm-type="click"
        data-gtm-clicktype="link"
        data-gtm-name="emissao do certificado"
        onClick={()=> handleCheckURL()}
      >

        <div className="course-item-icon">
          {courseFinishState || courseFinishedDB
            ? (
              <FaUnlock color={"#009ee2"}/>
            )
            : (
              <FaLock color={"#ff5a40"}/>
            )
          }
        </div>

        <img src={thumb_certificate}/>
      </a>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CoursePage/Components/ModuleCertificateComponent.jsx